// eslint-disable-next-line import/no-anonymous-default-export
export default {
  common: {
    yes: "হ্যাঁ",
    no: "না",
    na: "প্রযোজ্য নয়",

    good: "ভাল",
    satisfactory: "সন্তোষজনক",
    poor: "খারাপ",

    shgs: "স্বনির্ভর গোষ্ঠী (SHG)",
    others: "অন্যান্য",

    other: "অন্যান্য",
    other_material: "অন্যান্য উপাদান",
    other_materials: "অন্যান্য উপাদানসমূহ",

    not_applicable: "প্রযোজ্য নয়",

    thermocol_plates: "থার্মোকল প্লেট",
    aluminium_foil_plates: "অ্যালুমিনিয়াম ফয়েল প্লেট",
    aluminium_foil_packets: "অ্যালুমিনিয়াম ফয়েল প্যাকেট",

    steel_plates: "স্টিল প্লেট",
    plastic_plates: "প্লাস্টিক প্লেট",

    single_use_plastic_containers: "একবার ব্যবহারযোগ্য প্লাস্টিক পাত্র",

    remarks: "মন্তব্য",

    from: "থেকে",
    to: "পর্যন্ত",

    capture_or_upload_photo: "ফটো তুলুন বা আপলোড করুন",

    upload_document: "নথি আপলোড করুন",
    upload_supporting_file: "সহায়ক নথি আপলোড করুন",
    upload_the_current_months_housekeeping_record_for_verification: "বর্তমান মাসের হাউসকিপিং রেকর্ড আপলোড করুন",
    upload_the_half_yearly_health_checkup_records_for_verification: "অর্ধবার্ষিক স্বাস্থ্য পরীক্ষার রেকর্ড আপলোড করুন",

    last_refill_date: "শেষ রিফিলের তারিখ",
    last_pest_control_date: "শেষ পেস্ট কন্ট্রোলের তারিখ",
    last_health_checkup_date: "শেষ স্বাস্থ্য পরীক্ষার তারিখ",
    last_tank_cleaning_date: "শেষ ট্যাঙ্ক পরিষ্কারের তারিখ",
    last_water_quality_testing_date: "শেষ জলমান পরীক্ষার তারিখ",

    clean_and_stain_free_utensils: "পরিষ্কার এবং দাগ মুক্ত বাসন",
    clean_serving_counters_and_food_contact_surfaces: "পরিষ্কার পরিবেশন কাউন্টার এবং বাসন",
    use_of_clean_long_handle_spoons_for_serving_food: "খাদ্য পরিবেশনের জন্য পরিষ্কার লম্বা হ্যান্ডেল চামচ ব্যবহার করুন",
    food_kept_covered_during_storage: "সংরক্ষণ করার সময় খাবার ঢেকে রাখা হয়।",

    not_all_the_conditions_met: "কোন শর্ত পূরণ হয়নি",
  },
  home: {
    'findCanteen': "ক্যান্টিন খুঁজুন",
    'subtitle': "ক্যান্টিনগুলোর তালিকা পেতে অবস্থানের বিবরণ নির্বাচন করুন।",
    'district': "জেলা",
    'municipality': "পৌরসভা",
    'ward': "ওয়ার্ড",
    'canteenType': "ক্যান্টিন টাইপ",
    'searchCanteens': "ক্যান্টিন সার্চ করুন",
    'searching': "সার্চ করা হচ্ছে...",
    'startSurvey': "সার্ভে শুরু করুন",
    'viewSurvey': "সার্ভে দেখুন",
    'searchResults': "সার্চ ফলাফল",
  },
  survey: {
    'fullAddInput': "প্রতিষ্ঠানের পূর্ণ ঠিকানা প্রদান করুন",
    'instruction1':'পূরণ করতে একটি বিভাগে ট্যাপ করুন — জমা দিতে সবকটি পূরণ করুন।',
    'save&continue': "সেভ করুন ও এগিয়ে যান →",
    'saving': "সেভ হচ্ছে...",
    'saveSection': "সেভ করুন",
    'submitSurvey': 'জমা দিন',
    'backtosection': "← পিছনে আসুন",
  },
  surveyForms: {
    kiosk: {
      title: "কিয়স্ক সমীক্ষা",
      description: "মা ক্যান্টিন কিয়স্ক মূল্যায়ন"
    },
    kitchen: {
      title: "রান্নাঘর সমীক্ষা",
      description: "মা ক্যান্টিন রান্নাঘর মূল্যায়ন"
    },
    'kitchen-cum-dining': {
      title: "রান্নাঘর ও ডাইনিং সমীক্ষা",
      description: "মা ক্যান্টিন রান্নাঘর ও ডাইনিং মূল্যায়ন"
    }
  },
  settings: {
    title: "সেটিংস",
    subtitle: "আপনার অ্যাকাউন্টের তথ্য পরিচালনা করুন।",
    signedInAccount: "লগইন করা অ্যাকাউন্ট",
    noUserDetails:"এই অ্যাকাউন্টের জন্য কোনো ব্যবহারকারীর তথ্য উপলব্ধ নেই।",
    surveyLanguage: "সমীক্ষার ভাষা",
    selectLanguage: "ভাষা নির্বাচন করুন",
    languageDescription:"নির্বাচিত ভাষায় সমীক্ষার প্রশ্নগুলি প্রদর্শিত হবে।",
    logout: "লগআউট",
    user: "ব্যবহারকারী",
    notAvailable: "উপলব্ধ নয়",
    yes: "হ্যাঁ",
    no: "না",
    english: "English",
    bengali: "বাংলা", 
    accessRequired: "অবস্থান অনুমতি প্রয়োজন",
    accessBlocked: "অবস্থান অনুমতি ব্লক করা হয়েছে",
    accessUnsupported: "এই ডিভাইসে অবস্থান সুবিধা সমর্থিত নয়",
    requesting: "অবস্থান অনুমতি চাওয়া হচ্ছে",
    permissionTitle: "অবস্থান অনুমতি",
    permissionDescription:"অবস্থানভিত্তিক কার্যক্রমের জন্য এই ওয়েবসাইটে অবস্থান তথ্য প্রয়োজন।",
    browserPermissionMessage:"আপনার ব্রাউজার থেকে অবস্থান ব্যবহারের অনুমতি দিতে বোতামে ক্লিক করুন।",
    notNow: "এখন নয়",
    checking: "যাচাই করা হচ্ছে...",
    close: "বন্ধ করুন",
  },
  location: {
    title: "অবস্থান সেটিংস",
    subtitle:"প্রয়োজন হলে ওয়েবসাইট যেন আপনার বর্তমান অবস্থান ব্যবহার করতে পারে, তার জন্য অবস্থান অনুমতি দিন।",
    accessEnabled: "অবস্থান ব্যবহারের অনুমতি সক্রিয়",
    accessDescription:"আপনার ব্রাউজার থেকে অবস্থান ব্যবহারের অনুমতি দিতে নিচের বোতামে ক্লিক করুন।",
    allowLocation: "অবস্থান অনুমোদন করুন",
    latitude: "অক্ষাংশ",
    longitude: "দ্রাঘিমাংশ",
    accuracy: "নির্ভুলতা",
    meters: "মিটার",
    manualTitle: "ম্যানুয়ালি অবস্থান চালু করুন",
    chromeTitle: "ক্রোম বা এজ",
    chromeDescription:"অ্যাড্রেস বারের তালা (Lock) আইকনে ক্লিক করুন, Site Settings খুলুন, Location-কে Allow করুন এবং পৃষ্ঠাটি রিফ্রেশ করুন।",
    firefoxTitle: "ফায়ারফক্স",
    firefoxDescription:"অ্যাড্রেস বারের Location আইকনে ক্লিক করুন, ব্লক করা অনুমতি সরিয়ে আবার অবস্থান অনুমতি দিন।",
    androidTitle: "অ্যান্ড্রয়েড",
    androidDescription:"ব্রাউজারের Settings → Site Settings → Location-এ যান এবং এই ওয়েবসাইটের জন্য অনুমতি দিন।",
    iosTitle: "আইফোন বা আইপ্যাড",
    iosDescription:"Settings খুলুন, ব্রাউজার নির্বাচন করুন, Location চালু করুন এবং অনুরোধ করা হলে এই ওয়েবসাইটকে অনুমতি দিন।",
  },
  navbar:{
    logo: "মা ক্যান্টিন মনিটরিং",
    logoShort: "মা ক্যান্টিন",
    wbgovt: "পশ্চিমবঙ্গ সরকার",
    home: "হোম",
    survey: "সার্ভে",
    settings: "সেটিংস",
  }
};